import React, {useState, Fragment, useEffect} from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import {Container, Form} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen, faXmark} from "@fortawesome/free-solid-svg-icons";
import {accountService} from "./Account.service";
import Moment from "moment";

accountService.isLoggedRedirect();

function EducationAdmin() {
    const mytoken = JSON.parse(localStorage.getItem('token')).token;
    const config = {headers: { Authorization: `Bearer ${mytoken}` ,  } };
    const [dataedu, setDataEdu] = useState({
        school: '',
        degree: null,
        fieldofstudy: null,
        obtained: false,
        datestart: null,
        dateend: null,
        description: null,
        link: null,
        mycvid: null
    });
    const [showcreateedu, setShowCreateEdu] = useState(false);
    const [showeditedu, setShowEditEdu] = useState(false);
    const [editeduid, setEditEduid] = useState([]);
    const handleCloseCreateEdu = () => setShowCreateEdu(false);
    const handleCloseEditEdu = () => setShowEditEdu(false);
    const handleShowCreateEdu = () => setShowCreateEdu(true);
    const [idcv, setDataIdcv] =  useState([]);
    const [educations, setEducations] = useState([]);
    const [editdataedu, setEditDataEdu] = useState({
        school: null,
        degree: null,
        fieldofstudy: null,
        obtained: false,
        datestart: null,
        dateend: null,
        description: null,
        link: null,
        mycvid: null
    });
    const handleShowEditEdu = (id) => {
        console.log(id)
        setShowEditEdu(true)
        getEduById(id)
    }

    const getEdusList = () => {
        axios.get(`https://api.nvdxavier.com/api/education`, config)
            .then(data => {
                    setEducations(data.data);
                }
            ).catch(err => console.error(err));
    }
    const getCvIds = () => {
        axios.get(`https://api.nvdxavier.com/api/cvids`, config)
            .then(data => {
                    setDataIdcv(data.data);
                }
            ).catch(err => console.error(err));
    }
    useEffect(() => {
            getEdusList()
            getCvIds()
    }, [])
    const handleChange =(e) => {
        const { name, value, type, checked } = e.target;

        if(name === 'datestart' || name === 'dateend'){
            setDataEdu((prevChamps) => ({
                ...prevChamps,
                [name]: value+'T15:52:01+00:00',
            }));
        }else{
            setDataEdu((prevChamps) => ({
                ...prevChamps,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    }

    const handleChangeEdit =(e) => {
        const { name, value, type, checked } = e.target;

        if(name === 'datestart' || name === 'dateend'){
            setEditDataEdu((prevChamps) => ({
                ...prevChamps,
                [name]: value+'T15:52:01+00:00',
            }));
        }else{
            setEditDataEdu((prevChamps) => ({
                ...prevChamps,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    }
    const createEdu = (e) => {
        e.preventDefault()
        axios.post(`https://api.nvdxavier.com/api/education`, dataedu, config)
            .then(res => {
                res.status === 201 ? getEdusList() : console.log(res.status);
                res.status === 201 ? getCvIds() : console.log(res.status);
                res.status === 201 ? handleCloseEditEdu() : console.log(res.status)
                }
            ).catch(err => console.error(err))
    }

    const editEdu = (e) => {
        e.preventDefault()
        let idedu = e.target.eduid.value
            axios.put(`https://api.nvdxavier.com/api/education/`+idedu, editdataedu, config)
                .then(data => {
                    data.status === 200 ? getEdusList() : console.log(data.status)
                    data.status === 200 ? getCvIds() : console.log(data.status)
                    data.status === 200 ? handleCloseEditEdu() : console.log(data.status)
                    }
                ).catch(err => console.error(err))
    }

    const getEduById = (id) => {
        axios.get(`https://api.nvdxavier.com/api/education/`+id, config)
            .then(data => {
                setEditEduid(data.data)
                console.log(data.data)
                }
            ).catch(err => console.error(err))
    }

    const deleteEdu = (id) => {
        axios.delete(`https://api.nvdxavier.com/api/education/`+id,config )
            .then(res => {
                res.status === 204 ? getEdusList() : console.log(res.status);
                res.status === 204 ? getCvIds() : console.log(res.status);
            })
            .catch(err => console.error(err));
    }

   const isCvId = (editeduid, id) => {
        let careeriddatas =  editeduid.curriculum !== undefined ? editeduid.curriculum.id : 0;
        let response;
        response = (careeriddatas === id) && (id !== null);
        return response;
    }

    return (
        <Fragment>
            <Modal show={showcreateedu} onHide={handleCloseCreateEdu}>
                <span> school degree fieldofstudy obtained datestart dateend description link, idcv</span>
                <Container>
                    <div className="align-self-center" key="CurriculumAdminAlign">
                        <Form onSubmit={createEdu}>
                        <Form.Group controlId="formEducation" className="mb-8">
                            <Form.Label>école</Form.Label>
                            <Form.Control type="text" name="school" onChange={handleChange}/>
                            <Form.Label>Diplome</Form.Label>
                            <Form.Control type="text" name="degree" onChange={handleChange}/>
                            <Form.Label>champs d'études</Form.Label>
                            <Form.Control type="text" name="fieldofstudy" onChange={handleChange}/>
                            <Form.Group controlId="formEducation" className="mb-5">
                            <Form.Label>Du</Form.Label>
                            <Form.Control size="sm" type="date" name="datestart" onChange={handleChange} />
                            <Form.Label>au</Form.Label>
                            <Form.Control size="sm" type="date" name="dateend" onChange={handleChange} />
                            </Form.Group>
                            <Form.Group controlId="formDescription" className="mb-4">
                            <Form.Control size="md" as="textarea" name="description" placeholder="A propos de l'école" onChange={handleChange}/>
                            </Form.Group>

                            <Form.Label>Lien</Form.Label>
                            <Form.Control type="text" name="link" onChange={handleChange}/>
                            <Form.Group className="mb-3">
                                <Form.Label>Diplome obtenu ?</Form.Label>
                                    <Form.Check type="checkbox" name="obtained"
                                                id={dataedu.id}
                                        //defaultChecked={dataedu.obtained}
                                                onChange={handleChange}/>
                            </Form.Group>
                            <Form.Label>Curriculum:</Form.Label>
                            <Form.Select name="mycvid" key={"selectmyidcv"} onChange={handleChange} required="true">
                                {idcv.map((item) => {
                                    return (
                                        <option value={item.id}>{item.id}</option>
                                    )
                                })
                                }
                            </Form.Select>
                            <Button className="btn btn-danger btn-sm justify-content-center" type="submit">Créer</Button>
                        </Form.Group>
                    </Form>
                    </div>
                </Container>
            </Modal>
            <Modal show={showeditedu} onHide={handleCloseEditEdu}>
                <span> school degree fieldofstudy obtained datestart dateend description link, idcv</span>
                <Container>
                    <div className="align-self-center" key="CurriculumAdminAlign">
                        <Form onSubmit={editEdu}>
                            <Form.Group controlId="formEducation" className="mb-8">
                                <Form.Control type="text" name="eduid" value={editeduid.id} hidden="true"/>
                                <Form.Label>école</Form.Label>
                                <Form.Control type="text" name="school" defaultValue={editeduid.school} onChange={handleChangeEdit} />
                                <Form.Label>Diplome</Form.Label>
                                <Form.Control type="text" name="degree" defaultValue={editeduid.degree} onChange={handleChangeEdit}/>
                                <Form.Label>champs d'études</Form.Label>
                                <Form.Control type="text" name="fieldofstudy" defaultValue={editeduid.fieldofstudy} onChange={handleChangeEdit}/>
                                <Form.Group controlId="formEducation" className="mb-5">
                                    <Form.Label>Du</Form.Label>
                                    <Form.Control size="sm" type="date" defaultValue={Moment(editeduid.datestart).format('YYYY-MM-DD')} name="datestart" onChange={handleChangeEdit} />
                                    <Form.Label>au</Form.Label>
                                    <Form.Control size="sm" type="date" defaultValue={Moment(editeduid.dateend).format('YYYY-MM-DD')} name="dateend" onChange={handleChangeEdit} />
                                </Form.Group>
                                <Form.Group controlId="formDescription" className="mb-4">
                                    <Form.Control size="md" as="textarea" name="description" defaultValue={editeduid.description} onChange={handleChangeEdit}/>
                                </Form.Group>

                                <Form.Label>Lien</Form.Label>
                                <Form.Control type="text" name="link" defaultValue={editeduid.link} onChange={handleChangeEdit}/>
                                <Form.Group className="mb-3">
                                    <Form.Label>Diplome obtenu ?</Form.Label>
                                    <Form.Check type="checkbox" name="obtained"
                                                id={editeduid.id}
                                        defaultChecked={editeduid.obtained}
                                                onChange={handleChangeEdit}/>
                                </Form.Group>
                                <Form.Label>Curriculum:</Form.Label>
                                <Form.Select name="mycvid" key={editeduid.id} onChange={handleChangeEdit} required="true">
                                    {idcv.map((item) => {
                                        return (
                                            <option value={item.id} selected={isCvId(editeduid,item.id)}>{item.id}</option>
                                        )
                                    })
                                    }
                                </Form.Select>
                                <Button className="btn btn-danger btn-sm justify-content-center" type="submit">modifier</Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Container>
            </Modal>
            <section id="signup" className="signup-section">
                <Container key="EducationAdmin">
                    <h2>Gestion des diplomes</h2>
                    <div className="align-self-center">
                        <Button variant="warning" onClick={handleShowCreateEdu}>
                            <FontAwesomeIcon icon={faPen} />
                        </Button>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>Id</th>
                            <th>école</th>
                            <th>éducation</th>
                            <th>année</th>
                            <th>action</th>
                        </tr>
                        </thead>
                        <tbody>

                        {educations.map((value, index) => (
                                <tr key="">
                                 <th>{value.id}</th>
                                <th>{String(value.school)}</th>
                                <th>{String(value.degree)}</th>
                                <th>{Moment(value.datestart).format("DD/MM/YYYY")} au {Moment(value.dateend).format("DD/MM/YYYY")}</th>
                                <th>
                                    <Button variant="warning" onClick={() => handleShowEditEdu(value.id)}>
                                        <FontAwesomeIcon icon={faPen}/>
                                    </Button>
                                    <Button variant="danger" onClick={() => deleteEdu(value.id)}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </Button>
                                </th>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    </div>
                </Container>
            </section>
        </Fragment>
   )
}

export default EducationAdmin;